import DatabaseFactory from '@/wrappers/database'
import { addErrorLog } from '@/wrappers/database/utils/addLog'

const getWebStateRefresh = (store, personId) => {
  store.commit('clearListener')
  const id = personId || store.rootState.pillars.personId

  const database = new DatabaseFactory(`ehr_state/${id}`).getReadDatabase()

  const listener = database.getOneStream(
    doc => {
      if (!doc.exists()) return
      store.commit('setRefreshModules', doc.data())
    },
    error => {
      addErrorLog({
        context: 'getWebStateRefresh',
        error
      })
    }
  )

  store.commit('setListener', listener)
}

const clearListener = store => {
  store.commit('clearListener')
}

export default {
  getWebStateRefresh,
  clearListener
}
